var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardingTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9243",
    "data-name": "Group 9243",
    transform: "translate(-14259 -9096)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1803",
    "data-name": "Ellipse 1803",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(14259 9096)",
    fill: "#d34a7c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3",
    transform: "translate(14268.02 9105.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10428",
    "data-name": "Path 10428",
    d: "M23.32,9.73a6.46,6.46,0,1,1-6.46-6.46A6.46,6.46,0,0,1,23.32,9.73Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10429",
    "data-name": "Path 10429",
    d: "M21,28h7v1.4H21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10430",
    "data-name": "Path 10430",
    d: "M15,30v3a1,1,0,0,0,1,1H33a1,1,0,0,0,1-1V23a1,1,0,0,0-1-1H26V20.53a1,1,0,1,0-2,0V22H22V18.42A32.119,32.119,0,0,0,16.86,18a26,26,0,0,0-11,2.39,3.28,3.28,0,0,0-1.88,3V30Zm17,2H17V24h7v.42a1,1,0,0,0,2,0V24h6Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingTraining);
export default __webpack_public_path__ + "static/media/onboarding-training.53c2ff32805fa9540b32e18f9ca34dd0.svg";
export { ForwardRef as ReactComponent };